(function () {
  function normalizePhone(raw) {
    let phone = String(raw || '').replace(/\D/g, '');
    phone = phone.replace(/^0+/, '');
    // se vier só DDD+número (10/11), prefixa 55
    if (phone.length === 10 || phone.length === 11) phone = '55' + phone;
    return phone;
  }

  function init(root) {
    if (!root || root.dataset.wppInit === '1') return;
    root.dataset.wppInit = '1';

    const btnToggle = root.querySelector('#essence-wpp-whatsapp-chat-btn');
    const dialog = root.querySelector('#essence-wpp-whatsapp-chat-dialog');
    const btnClose = root.querySelector('#essence-wpp-whatsapp-chat-dialog-close');
    const form = root.querySelector('#essence-wpp-whatsapp-chat-dialog-user-form');
    const input = root.querySelector('#essence-wpp-whatsapp-chat-dialog-user-input');
    const msgText = root.querySelector('#essence-wpp-whatsapp-chat-dialog-msg-text');

    function hasDialogEnabled() {
      return String(root.getAttribute('data-has-dialog')) === 'true';
    }

    function getPhone() {
      const raw = root.getAttribute('data-whatsapp-number') || '';
      return normalizePhone(raw);
    }

    function openDialog() {
      if (!dialog) return;
      dialog.setAttribute('open', '');
      root.setAttribute('data-dialog-open', 'true');
      if (msgText) msgText.style.display = 'block';
      try { input && input.focus(); } catch(e) {}
    }

    function closeDialog() {
      if (!dialog) return;
      dialog.removeAttribute('open');
      root.setAttribute('data-dialog-open', 'false');
    }

    function openWhatsApp(text) {
      const phone = getPhone();
      if (!phone) return;

      const base = 'https://wa.me/' + phone;
      const url = text && String(text).trim()
        ? base + '?text=' + encodeURIComponent(String(text).trim())
        : base;

      window.open(url, '_blank', 'noopener,noreferrer');
    }

    // Clique no botão flutuante
    if (btnToggle) {
      btnToggle.addEventListener('click', function (e) {
        // trava qualquer JS antigo do tema
        e.preventDefault();
        e.stopImmediatePropagation();

        if (!hasDialogEnabled()) {
          openWhatsApp('');
          return;
        }

        const isOpen = root.getAttribute('data-dialog-open') === 'true';
        if (isOpen) closeDialog();
        else openDialog();
      }, true);
    }

    // Fechar dialog
    if (btnClose) {
      btnClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeDialog();
      }, true);
    }

    // Enviar mensagem
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const text = input ? input.value : '';
        openWhatsApp(text);
        if (input) input.value = '';
        closeDialog();
      }, true);
    }
  }

  function boot() {
    document.querySelectorAll('.whatsapp-popup#essence-wpp-whatsapp-chat').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor: quando a section recarrega
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target && e.target.querySelector && e.target.querySelector('.whatsapp-popup#essence-wpp-whatsapp-chat');
    if (root) init(root);
  });
})();
